<template>
    <div>
        
        <!--<b-alert show variant="info"><b-icon icon="info-circle"></b-icon> <i>Abnormal file count threshold</i> is set to <b>10</b> &amp; <i>Data Retention Deletion</i> runs every <b>15 seconds</b> for testing purposes.</b-alert>

        <ejs-tooltip position="TopCenter" content="Clears [delete]/[archive] flags on all attachments and <b>DELETES</b> all executions." style="display: inline;">
            <button type="button"
                    class="btn btn-warning mb-2"
                    @click="resetFileFlags()">
                <b>Reset Executions.</b> (For Testing)
            </button>
        </ejs-tooltip>-->

        <filter-ui :fields="getFilterFields()" ref="dataRetentionFilter" :apiBaseUrl="apiBaseUrl" relatedTo="dataRetention" :filter="initialFilter" v-on:change="filterChanged"></filter-ui>
        <!--<filter-ui ref="dataRetentionFilter" :api-base-url="this.$urlHelper.getApiUrl('DataRetention')" :fields="filterFields" relatedTo="dataRetentionGrid" :filter="initialFilter" v-on:change="filterChanged"></filter-ui>-->
        <ejs-grid :id="getInstallationAndVersionSpecificGridId('dataRetentionGrid')"
                  ref="dataRetentionGrid"
                  :dataSource="gridData"
                  :allowSorting="true"
                  :sortSettings="sortSettings"
                  :toolbar="toolbar"
                  :allowGrouping="false"
                  :groupSettings="groupSettings"
                  :allowResizing="true"
                  :allowPaging="true"
                  :pageSettings="pageSettings"
                  :showColumnChooser="true"
                  :allowExcelExport="true"
                  :dataStateChange="gridDataStateChanged"
                  :queryCellInfo="customiseCell"
                  :toolbarClick="toolbarClicked"
                  :rowSelected="rowSelectionChanged"
                  :rowDeselected="rowSelectionChanged"
                  :contextMenuItems="contextMenuItems"
                  :contextMenuClick="contextMenuClicked"
                  :contextMenuOpen="contextMenuOpened"
                  :detailTemplate="detailTemplate"
                  :headerCellInfo="headerCellInfoEvent"
                  :enableStickyHeader="true">
            <e-columns>
                <!-- :enablePersistence="true" -->
                <e-column field="name" :headerText="$t('Vue.Shared.Name')" width="100"></e-column>
                <e-column field="description" :headerText="$t('Vue.Shared.Description')"></e-column>
                <e-column field="createdDateTime" :headerText="$t('Vue.Shared.CreatedDateTime')"></e-column>
                <e-column field="createdBy" :headerText="$t('Vue.Shared.CreatedByUser')"></e-column>
                <e-column field="action.displayName" :headerText="$t('Vue.Shared.ActionToUndertake')"></e-column>
                <e-column field="active" :headerText="$t('Vue.Shared.Active')"></e-column>
                <!--<e-column field="reviewFileId" :headerText="$t('Entities.DataRetention.ReviewFile')" :template="cTemplate"></e-column>-->
                <e-column field="lastRunDateTime" :headerText="$t('Vue.Shared.LastExecutionDateTime')"></e-column>
                <e-column field="disabledDateTime" :headerText="$t('Vue.Shared.DisabledDateTime')" :visible="false"></e-column>
                <e-column field="disabledBy" :headerText="$t('Vue.Shared.DisabledByUser')" :visible="false"></e-column>



            </e-columns>

        </ejs-grid>

        <data-retention-rule-dialog :newRuleInitialData="ruleDialogData"
                                    :all-court-registry-options="allCourtRegistryOptions"
                                    :all-interview-organisation-options="allInterviewOrganisationOptions"
                                    :all-service-type-options="allServiceTypeOptions"
                                    :all-service-delay-options="allServiceDelayOptions"
                                    :all-order-status-options="allOrderStatusOptions"
                                    :all-data-retention-actions="allDataRetentionActions"
                                    :all-attachment-classifications="allAttachmentClassifications">
        </data-retention-rule-dialog>






        <b-modal size="xl"
                 centered
                 no-close-on-backdrop
                 no-close-on-esc
                 v-model="attachmentDialogData.dialogOpen"
                 v-on:cancel="resetAttachmentDialogData">
            <template #modal-header>
                <h5 class="modal-title">Affected Files:</h5>
            </template>
            <template #default>

                <b-table striped hover small v-if="attachmentDialogData.attachments != null" :items="attachmentDialogData.attachments" :fields="attachmentFields">

                    <template v-slot:cell(orders)="{value}">
                        <b-link v-for="order in value" :key="order.orderId" :href="$urlHelper.getPageUrl('orders',['edit',order.orderId])" target="_blank">{{order.epiqReference}} </b-link>
                    </template>

                </b-table>

                <button v-if="attachmentDialogData.attachments != null && attachmentDialogData.count > attachmentDialogData.attachments.length"
                        type="button"
                        class="btn btn-secondary"
                        @click="loadMoreAttachments()">
                    Load More
                </button>

            </template>
            <template #modal-footer="{ cancel }">
                <button type="button" class="btn btn-secondary" @click="cancel()">Cancel</button>
            </template>
        </b-modal>


        <b-modal size="xl"
                 centered
                 no-close-on-backdrop
                 no-close-on-esc
                 v-model="ruleHistoryDialogData.dialogOpen"
                 v-on:cancel="resetRuleHistoryDialogData">
            <template #modal-header>
                <h5 class="modal-title">Rule History:</h5>
            </template>
            <template #default>

                <entity-history-list name="entityHistory"
                                     entity-type-name="DataRetentionRule"
                                     :entity-id="ruleHistoryDialogData.ruleId">
                </entity-history-list>

            </template>
            <template #modal-footer="{ cancel }">
                <button type="button" class="btn btn-secondary" @click="cancel()">Cancel</button>
            </template>
        </b-modal>


    </div>
</template>

<script>
    import Vue from 'vue';
    import BootstrapVue from 'bootstrap-vue';
    import { GridPlugin, ColumnChooser, Resize, Sort, Group, Page, Toolbar, Search, ExcelExport, DetailRow, ContextMenu } from '@syncfusion/ej2-vue-grids';
    import { DataManager } from "@syncfusion/ej2-data";
    import axios from 'axios';

    import Attachments from '../Attachments.vue';
    Vue.component('attachments', Attachments);
    Vue.use(Attachments);

    import DataRetentionRuleDialog from '../DataRetentionRuleDialog.vue';
    Vue.component('data-retention-rule-dialog', DataRetentionRuleDialog);
    Vue.use(DataRetentionRuleDialog);

    import VueCurrencyInput from 'vue-currency-input'
    import { ValidationProvider, ValidationObserver } from 'vee-validate';


    import { extend, localize } from 'vee-validate';
    import { required, min_value, max_value, email } from 'vee-validate/dist/rules';
    import en from 'vee-validate/dist/locale/en.json';
    extend('required', required);
    extend('min_value', min_value);
    extend('max_value', max_value);
    extend('email', email);
    localize('en', en);

    import FilterUI from './FilterUI';

    import ErrorsMixin from '../../mixins/ErrorsMixin';
    import DateTimeMixin from '../../mixins/DateTimeMixin';
    import GridMixins from '../../mixins/GridMixins';
    import NumbersMixin from '../../mixins/NumbersMixin';
    import Select2 from '../Select2';

    Vue.use(BootstrapVue);
    Vue.use(GridPlugin)
    Vue.use(VueCurrencyInput);
    Vue.use(NumbersMixin);
    Vue.component('select2', Select2);
    Vue.component('validation-provider', ValidationProvider);
    Vue.component('validation-observer', ValidationObserver);

    import DataRetentionExecutionGridRow from './DataRetentionExecutionGridRow.vue';

    const EventBus = new Vue();
    //this is required to make the getGroupCaption function available globally and thus within the groupCaptionTemplate
    var dataRetentionGrid_vueComponent = null;
    function dataRetentionGrid_getGroupCaption(field, headerText, value) {
        return dataRetentionGrid_vueComponent.getGroupCaption(field, headerText, value);
    }
    window.dataRetentionGrid_getGroupCaption = dataRetentionGrid_getGroupCaption;

    export default {
        name: 'dataRetentionGrid',
        mixins: [ErrorsMixin, DateTimeMixin, GridMixins, NumbersMixin],
        components: {
            'filter-ui': FilterUI,
        },
        provide: {
            grid: [ColumnChooser, Resize, Sort, Group, Page, Toolbar, Search, ExcelExport, DetailRow, ContextMenu],
            eventBus: EventBus
        },
        props: {
            //allAsrStatusOptions: {
            //    type: Array,
            //    default: null
            //},
            //canCreateAsrRequests: {
            //    type: Boolean,
            //    default: false
            //},
            apiBaseUrl: {
                type: String,
                required: true
            },
            allCourtRegistryOptions: {
                type: Array,
                default: null
            },
            allInterviewOrganisationOptions: {
                type: Array,
                default: null
            },
            allServiceTypeOptions: {
                type: Array,
                default: null
            },
            allServiceDelayOptions: {
                type: Array,
                default: null
            },
            allOrderStatusOptions: {
                type: Array,
                default: null
            },
            allDataRetentionActions: {
                type: Array,
                default: null
            },
            allAttachmentClassifications: {
                type: Array,
                default: null
            },

        },
        data: function () {
            return {

                //cTemplate: function () {

                //    return {
                //        template: Vue.component('columnTemplate', {
                //            template: `<div v-if="!disabled">
                //                            <a :href="url">file</a>
                //                        </div>`,
                //            data: function () {
                //                return {
                //                    data: {},
                //                }
                //            },
                //            computed: {
                //                url: function () {
                //                    var dir = this.$urlHelper.getFileDownloadUrl("");
                //                    return dir+this.data.reviewFileId;
                //                },
                //                disabled: function () {
                //                    return this.data.reviewFileId == null;
                //                }
                //            }
                //        })
                //    }
                //},
                detailTemplate: function () {
                    return { template: DataRetentionExecutionGridRow };
                },


                groupSettings: { showGroupedColumn: true, disablePageWiseAggregates: true, captionTemplate: "${dataRetentionGrid_getGroupCaption(field, headerText, key)}" },
                pageSettings: { pageSize: 10, pageSizes: [5, 10, 25, 50] },

                initialized: false,
                filterFields: [
                    {
                        field: "CreatedDate",
                        label: "Created",
                        type: "date",
                        format: "dd/MM/yyyy"
                    },
                    {
                        field: "Action",
                        label: "Action",
                        type: "multiselect",
                        options: this.allDataRetentionActions,
                        placeholder: "Select Action"
                    },
                    {
                        field: "ActiveStatus",
                        label: "Active",
                        type: "boolean",
                    },
                    {
                        field: "DeletedDate",
                        label: "Deleted",
                        type: "date",
                        format: "dd/MM/yyyy"
                    },
                ],
                quickFilters: null,
                initialFilter: null,

                sortSettings: { columns: [{ field: "createdDateTime", direction: "Descending" }] },
                gridDataState: {
                    filter: null,
                    rule: null,
                    search: null,
                    sorted: [{ name: "createdDateTime", direction: "descending" }],
                    group: null,
                    skip: 0,
                    take: 10,
                    requiresCounts: true
                },
                gridData: { result: [], count: 0 },
                grid: null,

                //currentPayment: null,
                showErrors: false,
                currentErrors: null,

                columnFormats: {
                    'createdDateTime': {
                        type: 'datetime'
                    },
                    'lastRunDateTime': {
                        type: 'datetime'
                    },
                    'disabledDateTime': {
                        type: 'datetime'
                    },

                },

                contextMenuItems: [
                    { text: "Edit Rule", iconCss: "fas fa-pen", id: "editrule" },
                    { text: "View Change History", iconCss: "fas fa-history", id: "viewchangehistory" },
                    { text: "Delete Rule", iconCss: "fas fa-trash", id: "deleterule" },
                ],


                ruleDialogData: {
                    dialogOpen: false,
                    currentErrors: null,
                    busy: false,
                    disabled: false,
                    inputData: null,
                    selectedRow: null,
                    retentionAction: null,
                    activeStatus: true

                },
                attachmentDialogData: {
                    dialogOpen: false,
                    currentErrors: null,
                    busy: false,
                    disabled: false,
                    attachments: [],
                    count: 0,
                    execution: null,
                    pageNumber: 0,
                },
                ruleHistoryDialogData: {
                    dialogOpen: false,
                    currentErrors: null,
                    busy: false,
                    disabled: false,
                    ruleId: null,
                },
                attachmentFields: [
                    {
                        key: 'fileName',
                        label: 'File Name'
                    },
                    {
                        key: 'fileSize',
                        label: 'File Size',
                        formatter: (value) => {
                            var strVal = '';
                            if (value > (10 * 1024 * 1024 * 1024)) {
                                strVal = Math.round(value / (1024 * 1024 * 1024)) + ' GB';
                            } else if (value > (10 * 1024 * 1024)) {
                                strVal = Math.round(value / (1024 * 1024)) + ' MB';
                            } else if (value > (10 * 1024)) {
                                strVal = Math.round(value / 1024) + ' KB';
                            } else {
                                strVal = value + ' Bytes';
                            }
                            return strVal;
                        }
                    },
                    {
                        key: 'orders',
                        label: 'Orders'
                    },
                ]
            }
        },
        computed: {
            toolbar: function () {
                var toolbarItems = this.defaultEJ2DataGridToolbarItems({ grouping: false, export: true, columnchooser: true });

                toolbarItems =
                    toolbarItems.concat(
                        [
                            { text: "New Rule", tooltipText: "Create New Data Retention Rule", prefixIcon: "fas fa-plus", id: "newrule" },
                        ]
                    );



                return toolbarItems;
            },

        },
        watch: {
            "ruleDialogData.dialogOpen": function () {
                if (!this.ruleDialogData.dialogOpen) this.grid.refresh();
            }
        },
        methods: {
            getFilterFields: function () {
                var fields = [];
                fields.push(
                    {
                        field: "CreatedDate",
                        label: this.$t("Vue.Shared.CreatedDateTime"),
                        type: "date",
                        format: "dd/MM/yyyy"
                    },
                    {
                        field: "Action",
                        label: this.$t("Vue.Shared.ActionToUndertake"),
                        type: "multiselect",
                        options: this.allDataRetentionActions,
                        placeholder: "Select Action"
                    },
                    {
                        field: "ActiveStatus",
                        label: this.$t("Vue.Shared.Active"),
                        type: "boolean",
                    },
                    {
                        field: "DeletedDate",
                        label: this.$t("Vue.Shared.DisabledDateTime"),
                        type: "date",
                        format: "dd/MM/yyyy"
                    },
                );

                return fields;


            },
            getGroupCaption: function (field, headerText, value) {
                if (field == "createdDateTimeUTC") value = this.dateTimeDisplayString(value, 'includetime', true);
                else if (field == "processedDateTimeUTC") value = this.dateTimeDisplayString(value, 'includetime', true);
                return headerText + ": " + value;
            },
            customizeGroupKeys(groupedDate) {
                groupedDate.forEach(g => {
                    if (g.field && g.key && g.items) {
                        if (g.field == "createdDateTimeUTC") g.key = this.dateTimeDisplayString(g.key, 'includetime', false);
                        else if (g.field == "processedDateTimeUTC") g.key = this.dateTimeDisplayString(g.key, 'includetime', false);
                        this.customizeGroupKeys(g.items);
                    }
                });
            },

            resetRuleDialogData: function () {
                this.ruleDialogData = {
                    dialogOpen: false,
                    currentErrors: null,
                    busy: false,
                    disabled: false,
                    inputData: null,
                    selectedRow: null,
                    retentionAction: null,
                    activeStatus: true
                };
            },

            resetAttachmentDialogData: function () {
                this.attachmentDialogData = {
                    dialogOpen: false,
                    currentErrors: null,
                    busy: false,
                    disabled: false,
                    attachments: [],
                    count: 0,
                    execution: null,
                    pageNumber: 0,
                };
            },

            resetRuleHistoryDialogData: function () {
                this.ruleHistoryDialogData = {
                    dialogOpen: false,
                    currentErrors: null,
                    busy: false,
                    disabled: false,
                    ruleId: null,
                };
            },

            customiseCell: function (args) {
                //if ((args.column.field == 'reference') && (args.name == 'queryCellInfo') && args.data.enablePaymentLink) {
                //    args.cell.innerHTML = "<a href='" + this.paymentLinkBaseUrl + args.data.paymentId + "' target='_blank'>" + args.data.reference + "</a>";
                //}

                this.defaultEJ2DataGridQueryCellInfo(args, this.columnFormats);

                if (args.column.field == 'active') {
                    args.cell.innerHTML = args.data.active ? this.$t('Vue.Shared.Active') : this.$t('Vue.Shared.Disabled');
                }
            },
            filterChanged: function (filter) {
                this.gridDataState.filter = filter;
                if (this.initialized) this.grid.refresh();
            },
            ruleAdded: function (rule) {
                this.gridDataState.rule = rule;
                //if (this.initialized) this.grid.refresh();
            },
            contextMenuOpened: function (args) {
                var contextMenuObj = this.$refs.dataRetentionGrid.ej2Instances.contextMenuModule.contextMenu;
                var item = args.rowInfo.rowData;
                var hasItems = false;

                if (item == null) {
                    contextMenuObj.hideItems(["editrule"], true);
                }
                else {
                    contextMenuObj.showItems(["editrule"], true);
                    hasItems = true;
                }
                if (item == null) {
                    contextMenuObj.hideItems(["viewchangehistory"], true);
                }
                else {
                    contextMenuObj.showItems(["viewchangehistory"], true);
                    hasItems = true;
                }
                if (item == null) {
                    contextMenuObj.hideItems(["deleterule"], true);
                }
                else {
                    contextMenuObj.showItems(["deleterule"], true);
                    hasItems = true;
                }

                if (!hasItems) args.cancel = true;
            },
            contextMenuClicked: function (args) {
                if (args.item.id === 'editrule' || args.item.id === 'deleterule' || args.item.id === 'viewchangehistory') {
                    this.handleAction(args.item.id, args.rowInfo.rowData);
                }
            },
            toolbarClicked: function (args) {
                if (args.item.id === 'newrule') {
                    this.handleAction(args.item.id, this.grid.getSelectedRecords()[0]);
                } else if (args.item.id === 'excelexport') {
                    //to properly export all data (and not just the entries displayed on the current page) we have to load everything first
                    //we do this by taking the current grid state (which includes the current filter and search and sort settings)
                    var gridDataState = {
                        ...this.gridDataState
                    };
                    //but reset the skip and take to 0 which will return everything and unset the requiresCounts cause we are not interseted in the totals
                    gridDataState.requiresCounts = false;
                    this.grid.showSpinner();
                    this.loadDataRetentionRules(gridDataState)
                        .then(result => {
                            //the result is either false if something failed during the axios request, or it will contain the list in the result property which is what we have to pass to the actual export
                            if (result) {
                                var query = this.grid.getDataModule().generateQuery(true);
                                var groupedData = new DataManager(result.result).executeLocal(query);
                                this.grid.excelExport({ dataSource: groupedData });
                            }
                            this.grid.hideSpinner();
                        });
                } else {
                    this.defaultEJ2DataGridToolbarClickHandler(args, this.grid);
                }
            },
            gridDataStateChanged: function (args) {
                this.gridDataState.search = args.search;
                this.gridDataState.sorted = args.sorted;
                this.gridDataState.group = args.group;
                this.gridDataState.skip = args.skip;
                this.gridDataState.take = args.take;
                this.gridDataState.requiresCounts = args.requiresCounts;
                if (this.initialized) {
                    this.grid.showSpinner();
                    this.loadDataRetentionRules(this.gridDataState)
                        .then(result => {
                            if (result) {
                                this.gridData = result;
                            }
                            this.grid.hideSpinner();
                        });
                }
            },
            handleAction: function (action, selectedRow) {
                switch (action) {
                    case 'newrule':
                        this.resetRuleDialogData();
                        this.ruleDialogData.dialogOpen = true;
                        break;
                    case 'editrule':
                        this.resetRuleDialogData();
                        this.ruleDialogData.selectedRow = selectedRow;
                        this.ruleDialogData.dialogOpen = true;
                        break;
                    case 'viewchangehistory':
                        this.ruleHistoryDialogData.ruleId = selectedRow.id;
                        this.ruleHistoryDialogData.dialogOpen = true;
                        break;
                    case 'deleterule':
                        this.deleteRule(selectedRow);
                        break;
                }
            },

            rowSelectionChanged: function () {
                //if (args.name == 'rowSelected') {
                //    this.updateToolbarItems(this.grid.getSelectedRecords()[0])
                //} else {
                //    this.updateToolbarItems(null)
                //}
                return;
            },

            loadDataRetentionRules: function (gridDataState) {
                var url = this.$urlHelper.getApiUrl('DataRetention', 'list');

                return axios
                    .post(url, JSON.stringify(gridDataState), {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    })
                    .then(response => {
                        var gridData = response.data;
                        if (gridData && gridData.result) {
                            gridData.result = gridData.result.map((r) => {
                                if (r.createdDateTimeUTC) r.createdDateTimeUTC = this.parseDateTime(r.createdDateTimeUTC, true, true);
                                return r;
                            });
                        }
                        return gridData;
                    })
                    .catch(ex => {
                        var errors = this.handleAxiosException(ex);
                        this.showErrorsToast(errors);
                        return false;
                    });
            },

            deleteRule: function (selectedRow) {

                console.log(selectedRow);

                this.$bvModal.msgBoxConfirm('Are you sure you want to delete the rule named: ' + selectedRow.name, {
                    title: 'Please Confirm',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'YES',
                    cancelTitle: 'NO',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(value => {

                    if (value) {
                        var url = this.$urlHelper.getApiUrl('DataRetention');
                        axios
                        .delete(url + '/' + selectedRow.id)
                        .then(() => {

                            this.$bvToast.toast('Selected Rule has been deleted.', {
                                title: 'Rule Deleted',
                                variant: 'warning',
                                appendToast: true
                            });

                            this.grid.refresh();
                        })
                        .catch(ex => {
                            var currentErrors = this.handleAxiosException(ex);
                            this.$bvToast.toast(currentErrors, {
                                title: 'Error',
                                variant: 'danger',
                                appendToast: true
                            });
                        });
                    }
                })
            },

            loadMoreAttachments: function () {
                this.attachmentDialogData.pageNumber++;
                this.loadAttachments(this.attachmentDialogData.execution.dataRetentionExecutionId, this.attachmentDialogData.pageNumber);
            },
            loadAttachments: function (executionId, pageNumber = 0) {

                var url = this.$urlHelper.getApiUrl('DataRetention', 'listattachments', [executionId, pageNumber]);

                return axios
                    .get(url)
                    .then(response => {
                        this.attachmentDialogData.attachments = this.attachmentDialogData.attachments.concat(response.data.result);
                        this.attachmentDialogData.count = response.data.count;
                    })
                    .catch(ex => {
                        var errors = this.handleAxiosException(ex);
                        this.showErrorsToast(errors);
                        return false;
                    });
            },

            // REMOVE IN LIVE
            //resetFileFlags: function () {
            //    var url = this.$urlHelper.getApiUrl('DataRetention', 'resetfileflags');
            //    return axios
            //        .get(url)
            //        .then(() => {
            //            this.$bvToast.toast('Delete/Archive flags on all attachments have been reset.', {
            //                title: 'Flags Reset',
            //                variant: 'success',
            //                appendToast: true
            //            });
            //        })
            //        .catch(ex => {
            //            var errors = this.handleAxiosException(ex);
            //            this.showErrorsToast(errors);
            //            return false;
            //        });
            //},

            capitalizeFirstLetter: function (string) {
                return string.charAt(0).toUpperCase() + string.slice(1);
            }


        },
        created: function () {
            EventBus.$on("viewfiles", (execution) => {
                this.attachmentDialogData.dialogOpen = true;
                this.attachmentDialogData.execution = execution;
                this.loadAttachments(execution.dataRetentionExecutionId);
            });
        },
        mounted: function () {
            dataRetentionGrid_vueComponent = this;
            this.grid = this.$refs.dataRetentionGrid.ej2Instances;
            this.defaultEJ2DataGridCreatedHandler(this.grid);
            this.initialized = true;


            this.$refs.dataRetentionFilter.loadQuickFilters()
                .then(() => {
                    setTimeout(() => {
                        this.grid.refresh();
                    }, 250);
                });



        }
    }

</script>

<style>
    .e-toolbar-item .e-input-group input.e-input {
        height: 29px;
    }

    .e-pagerdropdown .e-input-group.e-control-wrapper input.e-input {
        height: 29px;
    }

    .e-rule-field {
        display: flex;
        align-items: center;
    }

    .e-template-value {
        flex-grow: 1;
    }

        .e-template-value .e-multiselect {
            max-width: none !important;
        }

        .e-template-value .e-multi-select-wrapper {
            max-width: none !important;
        }





    /* CONTEXT MENU STYLES */
    .e-contextmenu-wrapper .e-menu-parent .e-menu-item {
        height: 36px;
        font-size: 15px;
        display: flex;
        align-items: center;
    }

        .e-contextmenu-wrapper .e-menu-parent .e-menu-item .e-menu-icon {
            height: 20px;
            width: 20px;
            display: flex;
            align-items: center;
        }



    #deleterule, #deleterule *, #confirmexecution, #confirmexecution * {
        color: var(--danger);
        font-weight: bold;
    }

        #deleterule:hover, #confirmexecution:hover {
            background-color: var(--danger);
        }

            #deleterule:hover, #deleterule:hover *, #confirmexecution:hover, #confirmexecution:hover * {
                color: white;
            }
</style>